import {
  AppFreeAnswerRecordingCancelled,
  AppFreeAnswerRecordingError,
  AppFreeAnswerRecordingReady,
  AppFreeAnswerRecordingUploaded,
} from 'altru-types/@types/app-free-events';

const postAll = (payload: { kind: string }, origin = '*'): void => {
  window.parent.postMessage(payload, origin);

  // bubble up events in case this recording lives in a nested frame
  if (window.parent !== window.top) {
    window.top.postMessage({ kind: payload.kind }, '*');
  }
};

const sendRecordingReadyMessage = (payload: AppFreeAnswerRecordingReady, origin = '*'): void => {
  postAll(payload, origin);
};

const sendRecordingCancelledMessage = (payload: AppFreeAnswerRecordingCancelled, origin = '*'): void => {
  postAll(payload, origin);
};

const sendRecordingUploadedMessage = (payload: AppFreeAnswerRecordingUploaded, origin = '*'): void => {
  postAll(payload, origin);
};

const sendRecordingErrorMessage = (payload: AppFreeAnswerRecordingError, origin = '*'): void => {
  postAll(payload, origin);
};

export {
  sendRecordingReadyMessage,
  sendRecordingCancelledMessage,
  sendRecordingUploadedMessage,
  sendRecordingErrorMessage,
};
